// upiQrCode.jsx
import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

const UpiQrCode = ({CardCode,payeeName}) => {
  const upiId = `SSC483.0${CardCode}@hdfcbank`;
  // const upiId = `6382528587@ibl`;

  const upiLink = `upi://pay?pa=${upiId}&pn=${encodeURIComponent(payeeName)}`;
  return (                          
    <div style={{ textAlign: 'center' }}>
      <QRCodeSVG value={upiLink} size={100} />
      <p style={{ fontSize: '0.8rem', marginTop: '10px', marginBottom: 0 }}>UPI: {upiId}</p>

    </div>
  );
};

export default UpiQrCode;
